import { Component, OnInit, inject } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { closest } from '@frontend/sports/common/core/utils/list';
import { ActiveModal } from '@frontend/sports/modal/feature';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { HeadlineModel } from '@frontend/sports/types/components/intro-pages';
import { WINDOW } from '@frontend/vanilla/core';

@Component({
    selector: 'bs-betslip-deposit-details',
    templateUrl: './betslip-deposit-details.component.html',
    standalone: false,
})
export class DepositDetailsComponent implements OnInit {
    depositDetailsList: HeadlineModel[];
    imageSize: string;
    private readonly _window = inject(WINDOW);

    constructor(
        private activeModal: ActiveModal,
        public sitecore: Sitecore,
        private trustPipe: TrustPipe,
        private urlHelper: UrlHelperService,
    ) {}

    ngOnInit(): void {
        const imageProfile = [320, 480, 540, 640, 720, 1080];
        const closestWidth = closest(imageProfile, this._window.innerWidth);

        this.imageSize = 'width' + closestWidth;
    }

    getDepositDetailsLink(link: string): string {
        return this.urlHelper.getUrl(link);
    }

    html(source: string | undefined): SafeHtml {
        return this.trustPipe.transform(source ?? '', 'html');
    }

    close(callback: (data: boolean) => void): void {
        if (callback) {
            callback(true);
            this.activeModal.close();
        }
    }
}
